import moment from "moment";

export default class BeCuponUtils {
  static hasPermissionToView(currentUser, permissions) {
    return this.hasPermission(currentUser, permissions, 'view')
  }

  static hasPermissionToCreate(currentUser, permissions) {
    return this.hasPermission(currentUser, permissions, 'add')
  }

  static hasPermissionToUpdate(currentUser, permissions) {
    return this.hasPermission(currentUser, permissions, 'change')
  }

  static hasPermissionToDelete(currentUser, permissions) {
    return this.hasPermission(currentUser, permissions, 'delete')
  }

  static dateHumanization(date) {
    moment.locale('es');
    return moment(date).format('D MMMM YYYY')
  }

  static dateHumanizationSeparator(date) {
    moment.locale('es');
    if (typeof date === 'undefined' || date === null) {
      return;
    }
    if (date.includes('|')) {
      const [date1, date2] = date.split('|').map(date => date.trim());
      return [moment(date1).format('D MMMM YYYY'), moment(date2).format('D MMMM YYYY')];
    } else {
      return moment(date).format('D MMMM YYYY'); // Si no hay separador, se formatea la fecha directamente
    }
  }

  static dateTimeHumanization(date) {
    moment.locale('es');
    return moment(date).format('D MMMM YYYY, h:mm:ss a')
  }

  static formatDateTime(datetime) {
    moment.locale('es');
    return moment(String(datetime)).format('DD/MM/YYYY | HH:mm');
  }

  static formatDate(date) {
    moment.locale('es');
    return moment(String(date)).format('DD/MM/YYYY');
  }

  static priceHumanization(price, large) {
    if (price > 0){
      if (large) {
        return '$' + (price / 100).toFixed(2).toString().replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",") + ' MXN'
      } else {
        return '$' + price.toFixed(2).toString().replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",") + ' MXN'
      }
    } else {
      return '$ 0.00 MXN'
    }
  }

  static email(email) {
    return `mailto:${email}`
  }

  static last4Humanization(last4) {
    return last4 !== null ? '**** **** **** ' + last4 : '---'
  }

  static percentHumanization(percent) {
    return percent.toFixed(2).toString() + ' %'
  }

  static hasPermission(currentUser, permissions, action) {
    if (currentUser !== null && currentUser !== undefined) {
      if (currentUser.isStaff) return true;
      else {
        let has = false;
        let currentUserGroups = currentUser.groups;

        for (let i = 0; i < permissions.length && !has; i++) {
          for (let j = 0; j < currentUserGroups.length && !has; j++) {
            if(currentUserGroups[j].permissions)
            for (let k = 0; k < currentUserGroups[j].permissions.length && !has; k++) {
              if (currentUserGroups[j].permissions[k].name.includes(action) && currentUserGroups[j].permissions[k].name.includes(permissions[i])) {
                has = true
              }
            }
          }
        }
        return has;
      }
    }
    return false;
  }

  static isEmployment(currentUser) {
    if (currentUser !== null && currentUser !== undefined) {
      if (currentUser.employment !== null) {
        return currentUser.employment.branchOffice.id;
      }
    }
    return -1;
  }

  static isManager(currentUser) {
    if (currentUser !== null && currentUser !== undefined)
    if (currentUser.manager !== null) return currentUser.manager.company !== null ? currentUser.manager.company.id : -1;

    return -1;
  }

  static isAdmin(currentUser) {
    if (currentUser !== null && currentUser !== undefined) {
       return currentUser.isStaff;
    }
    return false;
  }

  static getTotalCouponAssigned(couponList) {
    var total = 0;

    for(var i=0; i < couponList.length; i++) {
      if(couponList[i].coupons !== null) {
          total += couponList[i].totalUses * couponList[i].coupons.maximumSales;
      }
    }

    return total;
  }

  static getTotalPaymentServices(services) {
    var total = 0.00;

    for(var i=0; i < services.length; i++) {
        total += services[i].price;
    }

    return total;
  }

  static getDistinct(list) {
    var distinct = [];

    for(var i=0; i < list.length; i++) {
        if(!distinct.includes(list[i])) distinct.push(list[i]);
    }

    return distinct;
  }

  static thousands(price) {
     return '$' + price.toLocaleString('en-US', {minimumFractionDigits: 2}) + ' MXN';
  }

}
